const base={}
base.install = function (Vue) {
  Vue.prototype.noShare = function (){
    // if (typeof WeixinJSBridge == 'undefined') {
    //   //微信浏览器内置对象。参考微信官方文档
    //   if (document.addEventListener) {
    //     document.addEventListener('WeixinJSBridgeReady', WeixinJSBridge.call('hideOptionMenu'), false)
    //   } else if (document.attachEvent) {
    //     document.attachEvent('WeixinJSBridgeReady', WeixinJSBridge.call('hideOptionMenu'))
    //     document.attachEvent('onWeixinJSBridgeReady', WeixinJSBridge.call('hideOptionMenu'))
    //   }
    // } else {
    //   WeixinJSBridge.call('hideOptionMenu')
    // }
  };
};
export default base;
